import { useNavigate } from "react-router-dom";
import { AlertTriangle, ShieldAlert, ChevronRight } from "lucide-react";

export function DashboardAlerts({ conflicts, shortages }) {
  const navigate = useNavigate();
  return (
    <>
      {conflicts.length > 0 && (
        <div data-testid="conflicts-alert" className="bg-red-500/10 border border-red-500/30 rounded-sm p-4 conflict-pulse cursor-pointer hover:bg-red-500/15 hover:border-red-500/50 transition-colors" onClick={() => navigate('/calendar')} role="button" tabIndex={0}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 text-red-400" />
              <span className="text-sm font-semibold text-red-400 uppercase tracking-wider">{conflicts.length} Scheduling Conflict{conflicts.length > 1 ? 's' : ''} Detected</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-red-400"><span>View in Calendar</span><ChevronRight className="w-3.5 h-3.5" /></div>
          </div>
          {conflicts.map((c) => (
            <p key={`${c.event1.event_id}-${c.event2.event_id}`} className="text-xs text-red-300/80 ml-6">
              <span className="font-medium">{c.event1.name}</span> &amp; <span className="font-medium">{c.event2.name}</span>
              {c.shared_gear.length > 0 && ` — ${c.shared_gear.length} gear conflict${c.shared_gear.length > 1 ? 's' : ''}`}
              {c.shared_crew.length > 0 && ` — ${c.shared_crew.length} crew conflict${c.shared_crew.length > 1 ? 's' : ''}`}
            </p>
          ))}
        </div>
      )}

      {shortages.length > 0 && (
        <div data-testid="shortage-forecast" className="bg-amber-500/10 border border-amber-500/30 rounded-sm p-4 cursor-pointer hover:bg-amber-500/15 hover:border-amber-500/50 transition-colors" onClick={() => navigate('/inventory')} role="button" tabIndex={0}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <ShieldAlert className="w-4 h-4 text-amber-400" />
              <span className="text-sm font-semibold text-amber-400 uppercase tracking-wider">{shortages.length} Gear Shortage{shortages.length > 1 ? 's' : ''} Predicted (Next 30 Days)</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-amber-400"><span>View Inventory</span><ChevronRight className="w-3.5 h-3.5" /></div>
          </div>
          {shortages.map((s) => (
            <div key={s.gear_id} className="text-xs text-amber-300/80 ml-6 mb-1">
              <span className="font-semibold">{s.name}</span>{' — '}need <span className="font-semibold">{s.peak_demand}</span>, have <span className="font-semibold">{s.total_quantity}</span>{' ('}short <span className="text-amber-300 font-bold">{s.shortage}</span>{') '}around {s.peak_date}
              {s.conflicting_events.length > 0 && <span className="text-amber-400/60">{' → '}{s.conflicting_events.map(e => e.name).join(' & ')}</span>}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
